import { type ModalProps } from "@common/controls/Modal/component";
import { type LeftTop } from "@common/hocs/draggable/lib";
import storage from "@common/lib/storage";

export const MODAL_INVISIBLE_PROPS: ModalProps = {
  cannotClose: false,
  hasBackdrop: false,
  isCentered: false,
  isDraggable: false,
  isLoading: false,
  isVisible: false,
  onClose: () => undefined,
  children: () => <any>null
};

const getKey = (storageId: string) => `${storageId}_MODAL_POSITION`.toUpperCase();

export type ModalState = LeftTop & {
  isEnlarged?: boolean;
  isPinned?: boolean;
};
export const getState = (storageId?: string, width?: number | string): ModalState => {
  let widthNumeric = !isNaN(Number(width)) ? Number(width) : 0;

  const mp = (storageId ? storage.get<Partial<ModalState>>(getKey(storageId)) : null) || {
    left: (window.innerWidth - (widthNumeric || 0)) / 2,
    top: 60
  };

  return {
    isEnlarged: mp.isEnlarged,
    isPinned: mp.isPinned,
    left: Math.max(mp.left ?? 0, 80),
    top: Math.max(mp.top ?? 0, 0)
  };
};
export const saveState = (state: Partial<ModalState>, storageId?: string) => {
  if (storageId) {
    const ms = getState(storageId);
    storage.set(getKey(storageId), { ...ms, ...state });
  }
};

export const isLargeScreen = () => window.innerWidth > 1920;
